// extracted by mini-css-extract-plugin
export default {"lineButtons":"realEstateItem_lineButtons__iuQxD","headers":"realEstateItem_headers__LRfWB","twoInLine":"realEstateItem_twoInLine__xNFNX"};